module.exports = __webpack_public_path__ + "img/icon_indi_zeroemission_off0.01d66a66.svg";